'use client';

import DefaultIcon from '@/assets/images/Andritz2.png';
import { useProductsSimple } from '@/domain/products/hooks';
import { removeFromCart } from '@/features/cart/store/cart';
import { type CartProduct } from '@/features/cart/types';
import { useSolutionStore } from '@/features/products/store/solution';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { IconButton } from '@andritzot/metris-web-ui/inputs/icon-button';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { DeleteOutlined } from '@mui/icons-material';
import { usePiwikPro } from '@piwikpro/next-piwik-pro';
import Image from 'next/image';
import Link from 'next/link';
import { useMemo } from 'react';

type CartItemCardProps = {
  cartProduct: CartProduct;
};

const CartItemCard = ({ cartProduct }: CartItemCardProps) => {
  const showType = useSolutionStore((s) => s.showType);
  const { data: products } = useProductsSimple(showType);
  const { eCommerce } = usePiwikPro();

  const productImageSrc = cartProduct.image2
    ? `${cartProduct.image2?.replace('Image', 'image')?.replace('Icons', 'icons')}`
    : DefaultIcon;

  const removeProduct = () => {
    eCommerce.ecommerceRemoveFromCart([
      {
        sku: `${cartProduct.idProduct}`,
      },
    ]);
    removeFromCart(cartProduct.idProduct);
  };

  const product = useMemo(
    () => products?.find((p) => p.idProduct === cartProduct.idProduct),
    [cartProduct.idProduct, products],
  );

  return (
    <Box
      sx={{
        
        display: 'flex',
        alignItems: 'center',
        px: 4,
      }}
    >
      <Box sx={{ p: 4 }}>
        <Image src={productImageSrc} width={24} height={24} alt={cartProduct.product} />
      </Box>
      <Box sx={{ flex: '1 1 0' }}>
        {product ? (
          <Link
            href={`/solutions/${cartProduct.idProduct}/`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            <Typography color="text.primary">
              {cartProduct.product}
            </Typography>
          </Link>
        ) : (
          cartProduct.product
        )}
        <Box sx={{ display: 'flex', alignItems: 'center', mt: '2px' }}>
          <Typography variant="body2" color="text.secondary">
            {cartProduct.group}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', pr: 4 }}>
        <IconButton onClick={removeProduct} variant="outlined" color="primary">
          <DeleteOutlined />
        </IconButton>
      </Box>
    </Box>
  );
};

export default CartItemCard;
